export enum PlasticMaterialMixingTaskStatus {
    Unassigned = "Unassigned",
    Waiting = 'Waiting',
    Released = "Released",
    Completed = "Completed",
    Canceled = "Canceled",
}